import { useDispatch, useSelector } from 'react-redux';
import useSystemSettingForm from '../../hooks/useSystemSettingForm ';
import {
  clearEditPropertySetting,
  updatePropertySetting,
} from '../../redux/actions/clients';
import { StoreState } from '../../types/state';
import EditDialog from '../Common/EditDialog';

const EditSetting = () => {
  const { clientId, setting, propertyId } = useSelector(
    (state: StoreState) => state.clients.editPropertySetting
  );
  const { settingSchema } = useSystemSettingForm(setting);
  const dispatch = useDispatch();

  if (!setting) return null;

  const handleUpdate = (data: any) => {
    dispatch(updatePropertySetting(data, clientId, propertyId));
  };

  return (
    <EditDialog
      update={handleUpdate}
      onClose={() => dispatch(clearEditPropertySetting())}
      formSchema={{
        ...settingSchema,
        title: `Edit Property Setting: ${propertyId}`,
      }}
      formData={setting}
    />
  );
};
export default EditSetting;
